/**
 * Labstep
 *
 * @module core/Card
 * @desc Card
 */

import cx from 'classnames';
import { Header } from 'labstep-web/core/Header';
import React from 'react';
import styles from './styles.module.scss';
import type { ICardProps } from './types';

/**
 * A simple card component. It will render the chldren inside a white
 * background with slightly round border edges
 */
export const Card: RFC<ICardProps> = ({
  children,
  className,
  header,
  size = 'small',
  ...rest
}) => {
  const classes = cx(styles.card, className);

  return (
    <div {...rest} className={classes}>
      {header && <Header size={size}>{header}</Header>}
      {children}
    </div>
  );
};
